import { action } from 'typesafe-actions';
// Generate identity
export const GENERATE_IDENTITY_REQUEST = '[Request] Generate Identity';
export const GENERATE_IDENTITY_SUCCESS = '[Success] Generate Identity';
export const GENERATE_IDENTITY_FAILURE = '[Failure] Generate Identity';
export const generateIdentityRequest = (address) => action(GENERATE_IDENTITY_REQUEST, { address });
export const generateIdentitySuccess = (address, identity) => action(GENERATE_IDENTITY_SUCCESS, { address, identity });
export const generateIdentityFailure = (address, error) => action(GENERATE_IDENTITY_FAILURE, { address, error });
//# sourceMappingURL=actions.js.map